import { createResponsiveType, baseTheme } from '@moonpig/launchpad-theme-common';
export * from '@moonpig/launchpad-theme-common';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { ColorPrimary01, ColorPrimary02, ColorPrimary03, ColorBlack00, ColorBlack05, ColorBlack10, ColorBlack20, ColorBlack30, ColorBlack40, ColorBlack50, ColorBlack60, ColorBlack70, ColorBlack80, ColorBlack90, ColorBlack100, ColorTextHeadline, ColorTextBody, ColorTextInverted, ColorTextAlternate, ColorTextLabel, ColorInteractionDefault, ColorInteractionHoverState, ColorInteractionFocusState, ColorInteractionButton, ColorInteractionButtonHover, ColorInteractionButtonFocus, ColorInteractionControl, ColorInteractionControlHoverFill, ColorInteractionDeactivated, ColorInteractionFocusIndicator, ColorInteractionIcon, ColorInteractionIconHover, ColorInteractionIconFavourite, ColorInteractionLoading, ColorInteractionSelectedState, ColorInteractionSelectedStateHover, ColorInteractionTextLink, ColorInteractionTextLinkHover, ColorInteractionTextLinkFocus, ColorInteractionBackgroundHover, ColorFeedbackSuccess, ColorFeedbackError, ColorFeedbackInformation, ColorFeedbackWarning, ColorFeedbackRating, ColorBackgroundSelectedState, ColorBackgroundSuccess, ColorBackgroundDeactivated, ColorBackgroundError, ColorBackgroundInformation, ColorBackgroundWarning, ColorBackgroundHoverState, ColorBackground01, ColorBackground02, ColorBackground03, ColorBackground04, ColorBackground05, ColorBackground06, ColorBackground07, ColorBackgroundHero, ColorBackgroundBranded, ColorBackgroundSite, ColorBorder01, ColorBorder02, ColorBorder03, ColorBorder04, ColorPillSponsored, ColorPillMembership, ColorPillEco, ColorPillMarketing, ColorPillUsp, ColorPillPrice, TypeMobileDisplay01, TypeDesktopDisplay01, TypeMobileDisplay02, TypeDesktopDisplay02, TypeMobileDisplay03, TypeDesktopDisplay03, TypeMobileDisplay04, TypeDesktopDisplay04, TypeMobileDisplay05, TypeDesktopDisplay05, TypeMobileDisplay06, TypeDesktopDisplay06, TypeMobileBodyLead, TypeDesktopBodyLead, TypeMobileBodyText, TypeDesktopBodyText, TypeMobileBodyCaption, TypeDesktopBodyCaption, TypeMobileBodyLabel, TypeDesktopBodyLabel, TypeMobileButtonLabel, TypeDesktopButtonLabel, TypeMobileButtonUnderlined, TypeDesktopButtonUnderlined, TypeMobileButtonTextLink, TypeDesktopButtonTextLink, FontFamilyPrimary, FontWeight300, FontWeight700 } from '@moonpig/launchpad-design-tokens/moonpig';

var colors = {
  colorPrimary01: ColorPrimary01,
  colorPrimary02: ColorPrimary02,
  colorPrimary03: ColorPrimary03,
  colorBlack00: ColorBlack00,
  colorBlack05: ColorBlack05,
  colorBlack10: ColorBlack10,
  colorBlack20: ColorBlack20,
  colorBlack30: ColorBlack30,
  colorBlack40: ColorBlack40,
  colorBlack50: ColorBlack50,
  colorBlack60: ColorBlack60,
  colorBlack70: ColorBlack70,
  colorBlack80: ColorBlack80,
  colorBlack90: ColorBlack90,
  colorBlack100: ColorBlack100,
  colorTextHeadline: ColorTextHeadline,
  colorTextBody: ColorTextBody,
  colorTextInverted: ColorTextInverted,
  colorTextAlternate: ColorTextAlternate,
  colorTextLabel: ColorTextLabel,
  colorInteractionDefault: ColorInteractionDefault,
  colorInteractionHoverState: ColorInteractionHoverState,
  colorInteractionFocusState: ColorInteractionFocusState,
  colorInteractionButton: ColorInteractionButton,
  colorInteractionButtonHover: ColorInteractionButtonHover,
  colorInteractionButtonFocus: ColorInteractionButtonFocus,
  colorInteractionControl: ColorInteractionControl,
  colorInteractionControlHoverFill: ColorInteractionControlHoverFill,
  colorInteractionDeactivated: ColorInteractionDeactivated,
  colorInteractionFocusIndicator: ColorInteractionFocusIndicator,
  colorInteractionIcon: ColorInteractionIcon,
  colorInteractionIconHover: ColorInteractionIconHover,
  colorInteractionIconFavourite: ColorInteractionIconFavourite,
  colorInteractionLoading: ColorInteractionLoading,
  colorInteractionSelectedState: ColorInteractionSelectedState,
  colorInteractionSelectedStateHover: ColorInteractionSelectedStateHover,
  colorInteractionTextLink: ColorInteractionTextLink,
  colorInteractionTextLinkHover: ColorInteractionTextLinkHover,
  colorInteractionTextLinkFocus: ColorInteractionTextLinkFocus,
  colorInteractionBackgroundHover: ColorInteractionBackgroundHover,
  colorFeedbackSuccess: ColorFeedbackSuccess,
  colorFeedbackError: ColorFeedbackError,
  colorFeedbackInformation: ColorFeedbackInformation,
  colorFeedbackWarning: ColorFeedbackWarning,
  colorFeedbackRating: ColorFeedbackRating,
  colorBackgroundSelectedState: ColorBackgroundSelectedState,
  colorBackgroundSuccess: ColorBackgroundSuccess,
  colorBackgroundDeactivated: ColorBackgroundDeactivated,
  colorBackgroundError: ColorBackgroundError,
  colorBackgroundInformation: ColorBackgroundInformation,
  colorBackgroundWarning: ColorBackgroundWarning,
  colorBackgroundHoverState: ColorBackgroundHoverState,
  colorBackground01: ColorBackground01,
  colorBackground02: ColorBackground02,
  colorBackground03: ColorBackground03,
  colorBackground04: ColorBackground04,
  colorBackground05: ColorBackground05,
  colorBackground06: ColorBackground06,
  colorBackground07: ColorBackground07,
  colorBackgroundHero: ColorBackgroundHero,
  colorBackgroundBranded: ColorBackgroundBranded,
  colorBackgroundSite: ColorBackgroundSite,
  colorBorder01: ColorBorder01,
  colorBorder02: ColorBorder02,
  colorBorder03: ColorBorder03,
  colorBorder04: ColorBorder04,
  colorPillSponsored: ColorPillSponsored,
  colorPillMembership: ColorPillMembership,
  colorPillEco: ColorPillEco,
  colorPillMarketing: ColorPillMarketing,
  colorPillUSP: ColorPillUsp,
  colorPillPrice: ColorPillPrice
};

var typography = {
  typeMobileDisplay01: TypeMobileDisplay01,
  typeDesktopDisplay01: TypeDesktopDisplay01,
  typeMobileDisplay02: TypeMobileDisplay02,
  typeDesktopDisplay02: TypeDesktopDisplay02,
  typeMobileDisplay03: TypeMobileDisplay03,
  typeDesktopDisplay03: TypeDesktopDisplay03,
  typeMobileDisplay04: TypeMobileDisplay04,
  typeDesktopDisplay04: TypeDesktopDisplay04,
  typeMobileDisplay05: TypeMobileDisplay05,
  typeDesktopDisplay05: TypeDesktopDisplay05,
  typeMobileDisplay06: TypeMobileDisplay06,
  typeDesktopDisplay06: TypeDesktopDisplay06,
  typeMobileBodyLead: TypeMobileBodyLead,
  typeDesktopBodyLead: TypeDesktopBodyLead,
  typeMobileBodyText: TypeMobileBodyText,
  typeDesktopBodyText: TypeDesktopBodyText,
  typeMobileBodyCaption: TypeMobileBodyCaption,
  typeDesktopBodyCaption: TypeDesktopBodyCaption,
  typeMobileBodyLabel: TypeMobileBodyLabel,
  typeDesktopBodyLabel: TypeDesktopBodyLabel,
  typeMobileButtonLabel: TypeMobileButtonLabel,
  typeDesktopButtonLabel: TypeDesktopButtonLabel,
  typeMobileButtonUnderlined: TypeMobileButtonUnderlined,
  typeDesktopButtonUnderlined: TypeDesktopButtonUnderlined,
  typeMobileButtonTextLink: TypeMobileButtonTextLink,
  typeDesktopButtonTextLink: TypeDesktopButtonTextLink,
  // responsive types
  typeDisplay01: createResponsiveType({
    xs: TypeMobileDisplay01,
    md: TypeDesktopDisplay01
  }),
  typeDisplay02: createResponsiveType({
    xs: TypeMobileDisplay02,
    md: TypeDesktopDisplay02
  }),
  typeDisplay03: createResponsiveType({
    xs: TypeMobileDisplay03,
    md: TypeDesktopDisplay03
  }),
  typeDisplay04: createResponsiveType({
    xs: TypeMobileDisplay04,
    md: TypeDesktopDisplay04
  }),
  typeDisplay05: createResponsiveType({
    xs: TypeMobileDisplay05,
    md: TypeDesktopDisplay05
  }),
  typeDisplay06: createResponsiveType({
    xs: TypeMobileDisplay06,
    md: TypeDesktopDisplay06
  }),
  typeBodyLead: createResponsiveType({
    xs: TypeMobileBodyLead,
    md: TypeDesktopBodyLead
  }),
  typeBodyText: createResponsiveType({
    xs: TypeMobileBodyText,
    md: TypeDesktopBodyText
  }),
  typeBodyCaption: createResponsiveType({
    xs: TypeMobileBodyCaption,
    md: TypeDesktopBodyCaption
  }),
  typeBodyLabel: createResponsiveType({
    xs: TypeMobileBodyLabel,
    md: TypeDesktopBodyLabel
  }),
  typeButtonLabel: createResponsiveType({
    xs: TypeMobileButtonLabel,
    md: TypeDesktopButtonLabel
  }),
  typeButtonUnderlined: createResponsiveType({
    xs: TypeMobileButtonUnderlined,
    md: TypeDesktopButtonUnderlined
  }),
  typeButtonTextLink: createResponsiveType({
    xs: TypeMobileButtonTextLink,
    md: TypeDesktopButtonTextLink
  })
};

var FONT_BASE_URL = 'moonpig.com/static/fonts';
var fontFaces = [{
  fontFamily: FontFamilyPrimary,
  fontWeight: FontWeight300,
  fontStyle: 'normal',
  sources: [{
    url: "".concat(FONT_BASE_URL, "/moonpig-light.woff2"),
    format: 'woff2'
  }, {
    url: "".concat(FONT_BASE_URL, "/moonpig-light.woff"),
    format: 'woff'
  }],
  fontDisplay: 'fallback'
}, {
  fontFamily: FontFamilyPrimary,
  fontWeight: FontWeight700,
  fontStyle: 'normal',
  sources: [{
    url: "".concat(FONT_BASE_URL, "/moonpig-bold.woff2"),
    format: 'woff2'
  }, {
    url: "".concat(FONT_BASE_URL, "/moonpig-bold.woff"),
    format: 'woff'
  }],
  fontDisplay: 'fallback'
}];

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var theme = _objectSpread(_objectSpread({}, baseTheme), {}, {
  colors: colors,
  // Nb. @material-ui/system currently looks for 'palette' on theme
  // This may change in https://github.com/mui-org/material-ui/issues/13663
  // at which point we could drop this alias
  palette: colors,
  typography: typography,
  fontFaces: fontFaces
});

export { theme, theme as themeDark };
